import { createContext } from 'react'

export const EpostFormContext = createContext()
